import $ from 'jquery';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ShowOnScroll, { fadePanUp } from '../../src/show-on-scroll';
import './style.scss';

gsap.registerPlugin(ScrollTrigger);

$(() => {
	if ($('.gfx').length === 0) return;

	// mobile transitions

	$('.cards-anim__mobile-img').each((index, el) => {
		ShowOnScroll(el, fadePanUp);
	});

	// Desktop animation

	if (window.innerWidth < 1023) return;

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: '.cards-anim',
			pin: '.gfx',
			start: 'top top', // when the top of the trigger hits the top of the viewport
			end: () => {
				const $block = $('.cards-anim__block:last-child');
				const topPos = $block.offset().top;
				const height = $block.outerHeight();
				const add = window.innerWidth >= 1200 ? 200 : 0;
				const middle = topPos + (height / 2) + add;
				return `${middle}px center`;
			},
			scrub: 1,
			// markers: true
		}
	});

	tl.addLabel('start');
	// tl.addPause(.5);
	tl.to('.gfx', {rotation: 0, duration: .7, ease: 'none'});
	tl.to('.gfx__pop-1', {top: '-2px', duration: .25, ease: 'none'}, '-=.25');
	tl.to('.gfx__pull-1', {top: '6px', duration: .25, ease: 'none'}, '-=.25');
	tl.addLabel('end_pt_1');
	tl.to('.gfx__group-1', {opacity: 0, scale: .8, duration: .3}, '-=.25');
	tl.to('.gfx__group-2', {opacity: 1, duration: .1, scale: 1}, '-=.25');
	tl.to('.gfx__group-2', {rotation: 0, duration: .15}, '-=.1');
	tl.to('.gfx__pull-2', {left: '221px', duration: .15}, '-=.15');
	tl.to('.gfx__pop-2', {left: '-231px', duration: .15}, '-=.15');
	tl.addPause(.2);
	tl.addLabel('end_pt_2');
	tl.set('.gfx__card-3', {opacity: 1, rotation: -180});
	tl.to('.gfx__pull-2', {left: 0, duration: .2});
	tl.to('.gfx__pop-2', {left: 0, duration: .2}, '-=.2');
	tl.to('.gfx__group-2', {left: '-250px', opacity: 0, duration: .2});
	tl.to('.gfx__card-3', {left: '+=150px', rotation: -90, duration: .2, ease: 'none'}, '-=.2');
	tl.to('.gfx__card-3', {left: '-=150px', rotation: 0, duration: .2});
	tl.to('.gfx__cover-3, .gfx__pop-3, .gfx__pull-3', {opacity: 1, duration: .25}, '-=.2');
	tl.addPause(.3);
	tl.addLabel('end_pt_3');
	tl.to('.gfx__group-3', {opacity: 0, top: '-200px', duration: .2});
	tl.to('.gfx__group-4', {opacity: 1, duration: .05}, '-=.2');
	tl.to('.gfx__pop-4', {top: '-105px', duration: .3});
	tl.to('.gfx__pull-4, .gfx__card-4', {top: '+=180px', duration: .3}, '-=.3');
	tl.addLabel('end_pt_4');
});